import React from 'react';
import { Button } from 'module-tsl-ui-elements';
import { getFromContext } from '../AlertFiltersContext';

export const AlertHeader = () => {
  const { state, dispatch } = getFromContext();
  const { id, updatedAt, createdAt, editing, prefix } = state;

  const hasId = Boolean(id);
  const alertStatus =
    (updatedAt && updatedAt.toString()) === (createdAt && createdAt.toString()) ? 'Created on ' : 'Updated on ';

  const displayDate = new Date(updatedAt).toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });

  return (
    <div className={`${prefix}__header`}>
      <span className={`${prefix}__header__icon`}>
        <i className="tds-icon icon--tds-alarm" />
      </span>
      {hasId ? (
        <span>
          {alertStatus}
          <time dateTime={`${updatedAt}`}>{displayDate}</time>
        </span>
      ) : (
        <span> New alert </span>
      )}

      {editing ? (
        <span className={`${prefix}__header--editing`}>Editing</span>
      ) : (
        <Button theme="tertiary" onClick={() => dispatch({ type: 'edit' })}>
          Edit alert
        </Button>
      )}
    </div>
  );
};
